module.exports = __webpack_public_path__ + "img/notitemchoosen.0cdabc2d.png";